import { graphql } from "../generated";

export const GetAnalyticsCallDisconnectedBy = graphql(`
  query GetAnalyticsCallDisconnectedBy($input: AnalyticsListInput!) {
    analyticsCallsHistory(input: $input) {
      __typename
      ... on AnalyticsCallsHistory {
        items {
          id
          disconnectedBy
        }
      }
      ... on GenericException {
        ...BaseException
      }
      ... on RetryableException {
        ...BaseException
      }
    }
  }
`);
